import { render, staticRenderFns } from "./ProdDetailsFits.vue?vue&type=template&id=090f6e02&scoped=true&"
import script from "./ProdDetailsFits.vue?vue&type=script&lang=js&"
export * from "./ProdDetailsFits.vue?vue&type=script&lang=js&"
import style0 from "./ProdDetailsFits.vue?vue&type=style&index=0&id=090f6e02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f6e02",
  null
  
)

export default component.exports